import { useTranslations } from "use-intl";
import { ExpandableSection } from "./ExpandableSection";

export function AdditionalInfoCard() {
  const t = useTranslations();

  return (
    <>
      <div className="section-title mt-4">{t("flights.additionalInfo")}</div>
      <div className="section-card mt-2">
        <ExpandableSection>
          <div className="flex w-full flex-col gap-2">
            <h3 className="text-sm font-medium text-text-primary">
              {t("flights.baggage.regulationsOnSpecialBaggage")}
            </h3>
            <p className="text-sm font-normal text-text-primary">
              {t("flights.regulationsDetails")}
            </p>
          </div>
        </ExpandableSection>
      </div>
    </>
  );
}
